import { ELoanPurpose } from '@if/core/types'
import { getEnvRuntimeVariable } from '@if/core/utils'

export const useDevTools = getEnvRuntimeVariable<boolean>(import.meta.env.VITE_USE_DEV_TOOLS)
export const merchantDashboardUrl = import.meta.env.VITE_MERCHANT_DASHBOARD_URL

export enum ELanguageAbr {
  French = 'fr',
  English = 'en',
}
export const ELanguageAbrList = Object.values(ELanguageAbr)

export enum EBannerOwnedFieldKey {
  NoPmtPolicy = 'NoPmtPolicy',
  HideAddress = 'HideAddress',
  SkipIncomeVerificationFlinks = 'SkipIncomeVerificationFlinks',
  CanPayBorrowers = 'CanPayBorrowers',
  AutoIncomeApproval = 'AutoIncomeApproval',
  CanUseHighEstimate = 'CanUseHighEstimate',
  AlwaysShowInterestRateMerchDb = 'AlwaysShowInterestRateMerchDb',
  WorksheetByMerchant = 'WorksheetByMerchant',
  MinimumApplicationStarPlan = 'MinimumApplicationStarPlan',
  AllowCoApplicant = 'AllowCoApplicant',
  // Composite: the whole Custom Buydown (plan + mode flag + notification emails).
  CustomBuydown = 'CustomBuydown',
}

export const starPlanValues = [1, 2, 3, 4, 5] as const

export enum EMerchantProperties {
  noPaymentPolicy = 'noPaymentPolicy',
  hideAddress = 'hideAddress',
  canSkipFlinks = 'canSkipFlinks',
  canPayBorrowers = 'canPayBorrowers',
  forcePaymentToBorrower = 'forcePaymentToBorrower',
  automaticIncomeApproval = 'automaticIncomeApproval',
  canAcceptHighEstimate = 'canAcceptHighEstimate',
  showInterestRateOnMerchantDashboard = 'showInterestRateOnMerchantDashboard',
  worksheetByMerchant = 'worksheetByMerchant',
  allowCoApplicant = 'allowCoApplicant',
}

export enum EMerchantReportFrequency {
  never = 'none',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}

export enum EValueList {
  Tags = 'Tags',
}

export enum EUserRights {
  canDeleteUser = 'canDeleteUser',
  canViewMerchantDashboard = 'canViewMerchantDashboard',
  canEditAdminFee = 'canEditAdminFee',
  canDownloadMerchDbAccessReport = 'canDownloadMerchDbAccessReport',
}

export const DATE_MAX = new Date('9999-12-31')

// Promotion mode for the merchant promotion tab (mutually exclusive).
export enum EPromotionMode {
  Preconfigured = 'preconfigured',
  Custom = 'custom',
}

// A merchant-built custom promotion is always created under this PromoPlan family.
export const CUSTOM_BUYDOWN_FAMILY = 'CustomBuydown'

// Lender admin fee accepted values. Mirrors MerchantsApi.Data.Enum.BorrowerFeeRateEnum (backend).
export const LENDER_ADMIN_FEE_VALUES = [0.06, 0.03, 0] as const

// Personal loan program constants
export const PERSONAL_MAX_LOAN_AMOUNT_DEFAULT = 40000
export const PERSONAL_MAX_LOAN_AMOUNT_MEDICARD = 50000
export const MEDICARD_SERVICE_CATEGORIES: string[] = [
  ELoanPurpose.Dentistry,
  ELoanPurpose.Medical,
  ELoanPurpose.Aesthetics,
]
